import React, {useEffect, useState} from 'react';
import {capitalizeArray, optionsToString, stringToArray, stringToOption} from "@app/utils/CommonUtils";
import JobBasicContent from "@pages/job/edit/JobBasicContent";
import JobCategoryContent from "@pages/job/edit/JobCategoryContent";
import {requestGetJob} from "@app/services/JobService";
import JobPermissionContent from "@pages/job/edit/JobPermissionContent";
import {callApiSaveJob} from "@pages/job/common/Services";
import {LOCAL_STORAGE_USER_LOGIN_INFO, ResponseCode} from "@app/constants/Common";
import JobRequirementContent from "@pages/job/edit/JobRequirementContent";
import JobOtherContent from "@pages/job/edit/JobOtherContent";
import {Document, Page} from "react-pdf";
import JobFileContent from "@pages/job/edit/JobFileContent";
import {requestGetEmployer} from "@app/services/EmployerService";

const EditJob = (props) => {
    const [job, setJob] = useState({});
    const [currentTab, setCurrentTab] = useState('job-permission-tab');
    const [userLoginInfo, setUserLoginInfo] = useState({});
    const [employer, setEmployer] = useState({});

    // const jobId = new URLSearchParams(props.location.search).get("jobId")
    const employerId = new URLSearchParams(props.location.search).get("employerId")
    const {jobId} = props.match.params

    const fetchEmployer = async (id) => {
        const res = await requestGetEmployer({employer_id: id});
        const emp = res.content
        if (emp) {
            setEmployer(emp)
        }
    };

    useEffect(() => {
        if (!userLoginInfo.id && localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)) {
            setUserLoginInfo(JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)))
        }

        if (employerId) {
            fetchEmployer(employerId)
        }

    }, [])

    useEffect(() => {
        if (userLoginInfo.is_superuser) {
            setCurrentTab('job-permission-tab')
        } else {
            setCurrentTab('job-basic-tab')
        }
    }, [userLoginInfo])

    const fetchJob = async (id) => {
        const res = await requestGetJob({job_id: id});
        if (res.content) {
            setJob(res.content)
        } else {
            setJob({})
        }
    };

    useEffect(() => {
        if (jobId) {
            fetchJob(jobId)
        } else if (!employerId) {
            alert('Vui lòng tạo Job từ một employer.')
        } else {
            setJob({employer_id: employerId})
        }
    }, []);

    const onTabClicked = (tabId) => {
        setCurrentTab(tabId);
    };

    const onSaveJob = () => {
        callApiSaveJob(job,  (res) => {
            if (res.sts_code === ResponseCode.SUCCESS) {
                if (!job.id) {
                    const changeJob = res.content
                    job.id = changeJob.id
                    setJob({...job})
                }
            }
        })
    };

    const activeTab = (tab) => {
        if (currentTab === tab) {
            return 'active'
        }
        return ''
    }

    const headerTitle = () => {
        if (!job.id) {
            return <h3 className='card-title font-weight-bold'>Thông tin job</h3>
        }
        return <h3 className='card-title'>
            {job.id && <span className={'mx-2'}>{job.id}</span>}
            {userLoginInfo.is_superuser && job.service_type && <> | <span className={'mx-2'}>{job.service_type}</span></>}
            {job.employer_brief_name && <> | <span className={'mx-2 text-primary text-bold h4'}>{job.employer_brief_name.toUpperCase()}</span></>}
            {job.job_title && <> | <span className={'mx-2 text-primary text-bold h4'}> {job.job_title.toUpperCase()}</span> </>}
            {job.job_status && <> | <span className={'mx-2'}>{job.job_status}</span></>}
            {job.local_province && <> | <span className={'mx-2'}>
                {capitalizeArray(stringToArray(job.local_province)).join(" - ")} </span></>
            }
            {job.min_salary !== false && <> | <span className={'mx-2'}>{job.min_salary}</span></>}
            {job.max_salary !== false && <> | <span className={'mx-2'}>{job.max_salary} </span></>}
            {job.created_date_time && <> | <span className={'mx-2'}>{job.created_date_time}</span></>}
        </h3>
    }

    return (
        <>
            {(employerId || jobId) &&
            <div className='card card-default'>
                <div className='card-header'>
                    <h3 className='card-title'><b>{headerTitle()}</b></h3>
                    <div className='card-tools'>
                        <button type='button' className='btn btn-primary mr-2 ml-3'
                                onClick={() => {
                                    onSaveJob()
                                }}>Save All
                        </button>
                    </div>
                </div>
                <div className='card-body row'>
                    <div className={'col-sm-6'}>
                        <JobFileContent jobInput={job} onChange={(changeJob) => {
                            job.id = changeJob.id
                            job.input_job_descriptions = changeJob.input_job_descriptions
                        }}/>
                    </div>
                    <div className={'col-sm-6'}>
                        <ul className='nav nav-tabs' role='tablist'>
                            {userLoginInfo.is_superuser &&
                                <li className='nav-item'>
                                    <a className={`nav-link ${activeTab('job-permission-tab')}`} data-toggle='tab' href='#job-permission-tab'
                                       onClick={() => onTabClicked('job-permission-tab')}>Phân quyền</a>
                                </li>
                            }
                            <li className='nav-item'>
                                <a className={`nav-link ${activeTab('job-basic-tab')}`} data-toggle='tab' href='#job-basic-tab'
                                   onClick={() => onTabClicked('job-basic-tab')}>TT cơ bản</a>
                            </li>
                            <li className='nav-item'>
                                <a className={`nav-link ${activeTab('job-category-tab')}`} data-toggle='tab' href='#job-category-tab'
                                   onClick={() => onTabClicked('job-category-tab')}>Phân loại</a>
                            </li>
                            <li className='nav-item'>
                                <a className={`nav-link ${activeTab('job-requirement-tab')}`} data-toggle='tab' href='#job-requirement-tab'
                                   onClick={() => onTabClicked('job-requirement-tab')}>Yêu cầu</a>
                            </li>
                            <li className='nav-item'>
                                <a className={`nav-link ${activeTab('job-other-tab')}`} data-toggle='tab' href='#job-other-tab'
                                   onClick={() => onTabClicked('job-other-tab')}>Others</a>
                            </li>
                        </ul>
                        <div className='tab-content'>
                            {userLoginInfo.is_superuser && currentTab === 'job-permission-tab' &&
                            <div id='job-permission-tab' className={`tab-pane ${activeTab('job-permission-tab')}`}
                                 style={{height: '83vh', overflow: 'auto'}}>
                                <JobPermissionContent jobId={job.id} onChange={(changeJob) => {
                                    job.id = changeJob.job_id
                                    job.hide_user_ids = changeJob.hide_users.map(item => {
                                        return item.value
                                    })
                                }}/>
                            </div>
                            }
                            {currentTab === 'job-basic-tab' &&
                            <div id='job-basic-tab' className={`tab-pane ${activeTab('job-basic-tab')}`}
                                 style={{height: '83vh', overflow: 'auto'}}>
                                <JobBasicContent jobInput={job} employerId={employerId} onChange={(changeJob) => {
                                    job.id = changeJob.id
                                    job.input_job_basic = {...changeJob.input_job_basic}

                                    if (userLoginInfo.is_superuser) {
                                        job.job_title = changeJob.job_title
                                    }
                                }}/>
                            </div>
                            }
                            {currentTab === 'job-category-tab' &&
                            <div id='job-category-tab' className={`tab-pane ${activeTab('job-category-tab')}`}
                                 style={{height: '83vh', overflow: 'auto'}}>
                                <JobCategoryContent jobInput={job} onChange={(changeJob) => {
                                    job.id = changeJob.id
                                    job.input_job_category = {...changeJob.input_job_category}
                                    // setJob({...job})
                                }}/>
                            </div>
                            }
                            {currentTab === 'job-requirement-tab' &&
                            <div id='job-requirement-tab' className={`tab-pane ${activeTab('job-requirement-tab')}`}
                                 style={{height: '83vh', overflow: 'auto'}}>
                                <JobRequirementContent jobInput={job} onChange={(changeJob) => {
                                    job.id = changeJob.id
                                    job.input_job_requirement = {...changeJob.input_job_requirement}
                                }}/>
                            </div>
                            }
                            {currentTab === 'job-other-tab' &&
                            <div id='job-other-tab' className={`tab-pane ${activeTab('job-other-tab')}`}
                                 style={{height: '83vh', overflow: 'auto'}}>
                                <JobOtherContent jobInput={job} employerId={employerId} onChange={(changeJob) => {
                                    job.id = changeJob.id
                                    job.input_job_other = {...changeJob.input_job_other}
                                }}/>
                            </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
            }
        </>
    )
}

export default EditJob;
